import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { extraSmallLayout } from "../../utils/device";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./c94_home_hero.scss"
import InnerHTML from 'dangerously-set-html-content';
import facebook from "../../assets/social_media_icons/facebook.svg";
import tiktok from "../../assets/social_media_icons/tiktok.svg";
import linkedin from "../../assets/social_media_icons/linkedin.svg";
import wechat from "../../assets/social_media_icons/wechat.svg";
import twitter from "../../assets/social_media_icons/twitter.svg";
import {ReactComponent as TwitterLogo} from "../../assets/social_media_icons/twitter.svg";
import youtube from "../../assets/social_media_icons/youtube.svg";
import instagram from "../../assets/social_media_icons/instagram.svg";
import clubhouse from "../../assets/social_media_icons/clubhouse.svg";
import podcast from "../../assets/social_media_icons/podcast.svg";
import {replaceComponentsCachedUrl, replaceImagesCachedUrl} from "../../utils/utils";

const SVG_ID = "#svg_id";
class C94HomeHero extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            btnHidden: '',
            dataIndex: null,
            disabled: false,
            slideIndex: 1,
            updateCount: 0
        };

        this.requireInternationalization = true;

        this.dataUrl = replaceComponentsCachedUrl(this.dataUrl);
    };

    internationalComponentRender(data, t) {
        data = replaceImagesCachedUrl(data);

        const title = (
            <div className="hero-title">
                <div className="sliding-titleX">
                    <h1 id='english'>{data.title}</h1>
                    {/* <h1 id='italian'>Benvenuto</h1>
                    <h1 style={{ fontSize: '6vw' }} id='chinese'>我们很高兴你来到这里</h1> */}
                </div>
                <h2>{data.subtitle}</h2>
                {/* <button><a href={data.link_url}><ArrowDown /></a></button> */}
                <div className="arrowContainer">
                    <div className="arrowDown">
                        <svg xmlns="http://www.w3.org/2000/svg" height="2.6vw" fill="#003A70" viewBox="0 0 384 512"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" /></svg>            </div>
                </div></div>)

        const caption = (
            <div className="caption-container">
                <div className="hero-caption">
                    <InnerHTML html={data.box_top_title} />
                </div>
                <div className="hero-caption-title">
                    {data.box_title}
                </div>
                <div className="hero-caption-body">
                    <InnerHTML html={data.box_content} />
                </div>
                {data.link_url && data.link_title && <button ><a style={{ color: 'white' }} href={data.link_url}>{data.link_title}</a></button>}
            </div>)

            const icons= (
                <Row className="hero-socials">
             
                    <div className="">
                        <a href="https://podcast.luiss.it/" className="social-link" aria-label="podcast">
                            <svg style={{fill:"green"}} className="mr-2 social-icon">
                                <use  xlinkHref={`${podcast}${SVG_ID}`} />
                            </svg>
                        </a>
                        <a href="https://www.facebook.com/uni.luiss" aria-label="Facebook">
                            <svg className="mr-2 social-icon">
                                <use xlinkHref={`${facebook}${SVG_ID}`} />
                            </svg>
                        </a>
                        <a href="https://vm.tiktok.com/4JAtqe/">
                            <svg className="mr-2 social-icon" aria-label="Tiktok">
                                <use xlinkHref={`${tiktok}${SVG_ID}`} />
                            </svg>
                        </a>
                        <a href="https://it.linkedin.com/school/luiss-guido-carli-university/">
                            <svg className="mr-2 social-icon" aria-label="LinkedIn">
                                <use xlinkHref={`${linkedin}${SVG_ID}`} />
                            </svg>
                        </a>
                        
                        <a href="https://weixin.qq.com/r/rRxQSBrECEd3rV4r90m-" aria-label="WeChat">
                            <svg className="mr-2 social-icon">
                                <use xlinkHref={`${wechat}${SVG_ID}`} />
                            </svg>
                        </a>
                        <a href="https://twitter.com/uniLUISS" aria-label="Twitter">
                          <TwitterLogo/>
                        </a>
   
                        <a href="https://www.youtube.com/user/LUISSGuidoCarli" aria-label="Youtube">
                            <svg className="mr-2 social-icon">
                                <use xlinkHref={`${youtube}${SVG_ID}`} />
                            </svg>
                        </a>
                        
                        <a href="https://www.instagram.com/uniluiss/" aria-label="Instagram">
                            <svg className="mr-2 social-icon">
                                <use xlinkHref={`${instagram}${SVG_ID}`} />
                            </svg>
                        </a>
                        <a href="https://www.joinclubhouse.com/club/luiss-university" aria-label="Clubhouse">
                            <svg className="mr-2 social-icon">
                                <use xlinkHref={`${clubhouse}${SVG_ID}`} />
                            </svg>
                        </a>
                    </div>
                  
          
            </Row>
            )

        return (
            <div className="home-hero" id="hero">
                {icons}
                {title}
                {caption}
            </div>)
    }
}

export default C94HomeHero;